import React from "react";
import "./EntityBadges.css";

/**
 * Shared entity badges — Organization / Creator / Project / Donation checkout.
 * One visual system everywhere (Sprint 2.0).
 */
export function buildEntityBadges(entity) {
  if (!entity) return [];
  const badges = [];
  if (entity.is_verified) {
    badges.push({ key: "verified", label: "Verified", mod: "verified" });
  }
  if (entity.is_featured) {
    badges.push({ key: "featured", label: "Featured", mod: "featured" });
  }
  if (entity.is_partner || entity.partner_id) {
    badges.push({ key: "partner", label: "Partner", mod: "partner" });
  }
  if (
    entity.is_official ||
    (entity.organization_type &&
      String(entity.organization_type).toLowerCase() === "official")
  ) {
    badges.push({ key: "official", label: "Official", mod: "official" });
  }
  if (entity.is_mission || entity.badge === "mission") {
    badges.push({ key: "mission", label: "Mission", mod: "mission" });
  }
  if (entity.entity_badge === "creator" || entity.badge === "creator") {
    badges.push({ key: "creator", label: "Creator", mod: "creator" });
  }
  if (
    entity.entity_badge === "organization" ||
    entity.badge === "organization"
  ) {
    badges.push({ key: "organization", label: "Organization", mod: "organization" });
  }
  if (entity.entity_badge === "project" || entity.badge === "project") {
    badges.push({ key: "project", label: "Project", mod: "project" });
  }
  return badges;
}

function EntityBadges({ entity, badges: badgesProp, className = "" }) {
  const badges =
    Array.isArray(badgesProp) && badgesProp.length
      ? badgesProp
      : buildEntityBadges(entity);

  if (!badges.length) {
    return null;
  }

  return (
    <span
      className={"entity-badges" + (className ? " " + className : "")}
      aria-label="Badges"
    >
      {badges.map((b) => (
        <span
          key={b.key || b.label}
          className={"badge entity-badge entity-badge--" + (b.mod || "default")}
        >
          {b.label}
        </span>
      ))}
    </span>
  );
}

export default EntityBadges;
